/* eslint-disable prettier/prettier */
import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import Shimmer from 'react-native-shimmer';

import { scale } from '@components/frame';
import { convertTimeLetter, isWeb } from '@helpers';

import { font } from '@styles/fonts';
import { useHandleNavigationMachinesHeader } from '@v2/pages/machines/hooks/useHandleNavigationMachineHeader';
import { MachinesScreen } from '@v2/pages/machines/common/enums';

const Line = ({ h, m, width, colorTime, backgroundColor, totalLoaded, maxWidth, listWidth, C }) => {
  if (!totalLoaded) {
    return (
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <Shimmer>
          <View
            style={{
              height: scale(16),
              paddingHorizontal: scale(4),
              borderRadius: scale(3),
              justifyContent: 'center',
              minWidth: (maxWidth / 100) * listWidth,
              backgroundColor: C('Gray/Light/3'),
            }}
          ></View>
        </Shimmer>
      </View>
    );
  }
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <View
        style={{
          height: scale(16),
          paddingHorizontal: scale(1),
          borderRadius: scale(3),
          justifyContent: 'center',
          width,
          backgroundColor: C(backgroundColor),
        }}
      />
      <Text style={{ color: C(colorTime), marginLeft: scale(4) }} numberOfLines={1}>
        <Text style={[font['Button 3']]}>{h}</Text>
        <Text style={[font['Small']]}>{i18n.t('h')} </Text>
        <Text style={[font['Button 3']]}>{m}</Text>
        <Text style={[font['Small']]}>{i18n.t('m')}</Text>
      </Text>
    </View>
  );
};

export default ({ item, C, selected, maxWidth = isWeb ? 50 : 65, paddingLeft = 5.5, listWidth }) => {
  const {activePerformanceSubScreenName} = useHandleNavigationMachinesHeader();

  const { machineStatistics, maxValueActive, maxValueProductive, hasNoDataInPeriod } = item;

  // do not render time bars for machines without data in the selected period
  if (hasNoDataInPeriod || !machineStatistics) {
    return null;
  }

  const { totalActiveSecs, totalProductiveSecs, totalActiveSecsPrevious, totalProductiveSecsPrevious, totalLoaded } = machineStatistics;

  const isActive = activePerformanceSubScreenName === MachinesScreen.ACTIVE;

  const todayColor = isActive ? 'Status/Light/Active hatch' : 'Status/Light/Productive';

  const maxGlobal = isActive ? maxValueActive : maxValueProductive;
  const totalSecs = isActive ? totalActiveSecs : totalProductiveSecs;
  const totalPreviousSecs = isActive ? totalActiveSecsPrevious : totalProductiveSecsPrevious;
  const total = convertTimeLetter(totalSecs);
  const totalPrevious = convertTimeLetter(totalPreviousSecs);

  const max = Math.max(totalSecs, totalPreviousSecs);
  const min = Math.min(totalSecs, totalPreviousSecs);

  const widthMax = `${(max * maxWidth) / maxGlobal}%`;
  const widthMin = `${(min * maxWidth) / maxGlobal}%`;

  const isTodayMore = totalSecs > totalPreviousSecs;
  return (
    <View style={{ width: '100%', paddingLeft: scale(paddingLeft), zIndex: 0 }}>
      <View style={{ marginTop: scale(2) }}>
        <Line
          {...{
            colorTime: selected ? 'Label/Light/AlwaysLight Primary' : todayColor,
            backgroundColor: selected && !isActive ? 'Label/Light/AlwaysLight Primary' : todayColor,
            width: isTodayMore ? widthMax : widthMin,
            totalLoaded,
            maxWidth,
            listWidth,
            C,
            ...total,
          }}
        />
      </View>
      <View style={{ marginTop: scale(7) }}>
        <Line
          {...{
            colorTime: 'Gray/Light/2',
            backgroundColor: 'Gray/Light/2',
            width: isTodayMore ? widthMin : widthMax,
            totalLoaded,
            maxWidth,
            listWidth,
            C,
            ...totalPrevious,
          }}
        />
      </View>
    </View>
  );
};
